import styles from "./difficultyColors.module.css";

export type DifficultyRating = 1 | 2 | 3 | 4 | 5;

/** Returns the CSS module class that colours background + text for a rating. */
export const getDifficultyColor = (rating: DifficultyRating): string =>
  styles[`difficultyRating${rating}`];

/** Returns the CSS module class that colours only the text for a rating. */
export const getDifficultyTextColor = (rating: DifficultyRating): string =>
  styles[`difficultyText${rating}`];
